import { devWarn } from "@/lib/devLog";
// Small helper: play a friendly two-tone chime via the Web Audio API.
// No external assets — works everywhere Web Audio is supported (mobile Safari,
// Chrome, Firefox). One AudioContext instance is created lazily so browsers
// don't complain about "the AudioContext was not allowed to start" before a
// user gesture happens.
let _ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!_ctx) _ctx = new Ctor();
  return _ctx;
}

/** Unlock the AudioContext — call inside a user gesture (login, tap, etc.) */
export async function unlockAudio() {
  const ctx = getCtx();
  if (!ctx) return false;
  if (ctx.state === "suspended") {
    // resume() throws until the browser has seen a user gesture — expected on first load.
    try { await ctx.resume(); } catch (e) { devWarn("beep.resume", e); }
  }
  return ctx.state === "running";
}

/** Play a short two-note notification chime. */
export function playNotificationChime() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});

  const now = ctx.currentTime;
  const master = ctx.createGain();
  master.gain.value = 0.0001;
  master.gain.exponentialRampToValueAtTime(0.28, now + 0.02);
  master.gain.exponentialRampToValueAtTime(0.0001, now + 0.55);
  master.connect(ctx.destination);

  const tones = [
    { f: 880, at: 0.0, dur: 0.18 },     // A5
    { f: 1174.66, at: 0.14, dur: 0.28 }, // D6
  ];
  for (const t of tones) {
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(t.f, now + t.at);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, now + t.at);
    g.gain.exponentialRampToValueAtTime(0.9, now + t.at + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, now + t.at + t.dur);
    osc.connect(g);
    g.connect(master);
    osc.start(now + t.at);
    osc.stop(now + t.at + t.dur + 0.02);
  }
}
